import React, { Component } from "react";
import Logo from "../images/JC-logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faEnvelope,
  faPlay,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookF,
  faPinterestP,
  faInstagram,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";

export default class Footer extends Component {
  render() {
    const container = {
      maxWidth: "1200px",
      margin: "0 auto",
      padding: "40px 20px",
      color: "#fff",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    };

    const footerStyle = {
      backgroundColor: "#001F3F", // Matches header
    };

    const heading = {
      fontSize: "16px",
      fontWeight: "bold",
      marginBottom: "15px",
      textTransform: "uppercase",
      color: "#fff",
    };

    const paragraph = {
      fontSize: "14px",
      lineHeight: "1.7",
      color: "#ccc",
    };

    const link = {
      display: "block",
      color: "#bbb",
      fontSize: "14px",
      marginBottom: "8px",
      textDecoration: "none",
    };

    const iconStyle = {
      fontSize: "14px",
      marginRight: "8px",
      color: "#ccc",
    };

    const socialIcon = {
      color: "#fff",
      fontSize: "18px",
      marginRight: "15px",
      transition: "color 0.3s",
    };

    const appButton = {
      display: "inline-flex",
      alignItems: "center",
      backgroundColor: "#004080",
      color: "#fff",
      padding: "8px 12px",
      fontSize: "13px",
      borderRadius: "5px",
      marginRight: "10px",
      marginTop: "8px",
      cursor: "pointer",
      textDecoration: "none",
    };

    const bottomText = {
      borderTop: "1px solid #004080",
      marginTop: "30px",
      paddingTop: "15px",
      fontSize: "13px",
      color: "#aaa",
      textAlign: "center",
    };

    return (
      <footer style={footerStyle}>
        <div style={container}>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "40px" }}>
            {/* Column 1 */}
            <div style={{ flex: "1 1 250px", minWidth: "220px" }}>
              <img
                src={Logo}
                alt="JC Creations"
                style={{
                  width: "150px",
                  marginBottom: "15px",
                
                }}
              />
              <p style={paragraph}>
                Designs that speak for themselves. JC Creations offers a variety
                of customized products for your needs.
              </p>
              <p style={paragraph}>
                <FontAwesomeIcon icon={faPhone} style={iconStyle} />
                +91 8310 726 160
              </p>
              <p style={paragraph}>
                <FontAwesomeIcon icon={faEnvelope} style={iconStyle} />
                jc.creations99@gmail.com
              </p>
            </div>

            {/* Column 2 */}
            <div style={{ flex: "1 1 200px", minWidth: "180px" }}>
              <h5 style={heading}>Customer Service</h5>
              <a href="/contact-us" style={link}>
                Contact Us
              </a>
              <a href="/sitemap" style={link}>
                Site Map
              </a>
            </div>

            {/* Column 3 */}
            <div style={{ flex: "1 1 250px", minWidth: "200px" }}>
              <h5 style={heading}>Company Information</h5>
              <a href="/about-us" style={link}>
                About Us
              </a>
              <a href="/pricing" style={link}>
                Pricing
              </a>
              <a href="/returnsandcancellation" style={link}>
                Return & Cancellation
              </a>
              <a href="/privacy-policy" style={link}>
                Privacy Policy
              </a>
              <a href="/terms-and-conditions" style={link}>
                Terms & Conditions
              </a>
            </div>

            {/* Column 4 */}
            <div style={{ flex: "1 1 250px", minWidth: "220px" }}>
              <h5 style={heading}>Get in Touch</h5>
              <div style={{ marginBottom: "15px" }}>
                <a
                  href="https://www.facebook.com/JC.9099/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={socialIcon}
                >
                  <FontAwesomeIcon icon={faFacebookF} />
                </a>
                <a
                  href="https://in.pinterest.com/jccreations99/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={socialIcon}
                >
                  <FontAwesomeIcon icon={faPinterestP} />
                </a>
                <a
                  href="https://www.instagram.com/jc_designcreations/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={socialIcon}
                >
                  <FontAwesomeIcon icon={faInstagram} />
                </a>
                <a
                  href="https://www.whatsapp.com/channel/0029Va9J1qv1CYoTxw9rUY25"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={socialIcon}
                >
                  <FontAwesomeIcon icon={faWhatsapp} />
                </a>
              </div>

              <h6 style={{ ...heading, fontSize: "13px", marginBottom: "8px" }}>
                Download Our App
              </h6>
              <a href="https://play.google.com/store/apps/details?id=com.jccreations&hl=en" target="blank" style={appButton}>
                <FontAwesomeIcon icon={faPlay} style={{ marginRight: "6px" }} />{" "}
                Google Play
              </a>
              {/* <a href="#" style={appButton}>
                <FontAwesomeIcon icon={faApple} style={{ marginRight: "6px" }} />{" "}
                App Store
              </a> */}
            </div>
          </div>

          {/* Footer Bottom */}
          <div style={bottomText}>
            <p style={{color: "white"}}>
              © 2024 <strong>JC Creations</strong>. All Rights Reserved.
            </p>
            {/* <p>Made with ❤️ by JC Development Team</p> */}
          </div>
        </div>
      </footer>
    );
  }
}
